import React, { useEffect, useRef, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import html2pdf from 'html2pdf.js';
import { Link } from "react-router-dom";
import FormatDateString from "../dateFormat";
import AddComment from "./AddComment";
import ModifyComment from "./ModifyComment";
import vAdminformat from '../../adminFormat';
import QRCode from "react-qr-code";
import { useReactToPrint } from 'react-to-print';
import validateError from "../../ValidateError";
import { PieChart, Pie, Cell } from "recharts";

import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";

const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const CollectiveQRForm = ({ onRenderComplete, group }) => {


    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState(null);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [currentComment, setCurrentComment] = useState("");
    const [currentPart, setCurrentPart] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [collective, setCollective] = useState([]);

    useEffect(() => {
        
        const CollectiveQR = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/jobs/manual/collective?id=${parseFloat(group)}`, headers);
                if (response.data.RES_CODE === "00") {
                    const data = (response.data.RES_RESULT);
                    console.log("Unexpected error, please check")
                    setCollective(data);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            } finally {
                setLoading(false)
                onRenderComplete && onRenderComplete()
            }
        }
        CollectiveQR();
        
    }, []);


    const CollectiveQR = async () => {
        try {
            const response = await axios.get(`${server_backend}/jobs/manual/collective?id=${group}`, headers);
            if (response.data.RES_CODE === "00") {
                const data = (response.data.RES_RESULT);
                setCollective(data);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        } finally {
            setLoading(false)
            onRenderComplete && onRenderComplete()
        }
    }

    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });

    const handleClick = () => {

        setShowPrintableDiv(true);
        setTimeout(() => {
            handlePrint();
        }, 2000);

    };

    const [imageURL, setImageURL] = useState(null);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const image = await SimpleSTLViewerToImage(fileURL);

                setImageURL(image);
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        };

        if (fileURL) {
            loadImage();
        }
    }, [fileURL]);

    const StatusChart = ({ statusId, reprint }) => {

        const COLORS = ["#FF0000", "#FF7F50", "#FFFF00", "#008000"];

        if (statusId === 18 && reprint === false) {
            return <i className="ri-folder-open-line" style={{ fontSize: "45px", color: "#555" }}></i>;
        }
        if (statusId === 18 && reprint === true) {
            return <i className="ri-folder-add-line" style={{ fontSize: "45px", color: "#555" }}></i>;
        }

        let filledSections = 0;
        if (filledSections > 22) filledSections = 4;
        switch (statusId) {
            case 19: filledSections = 1; break;
            case 20: filledSections = 2; break;
            case 21: filledSections = 3; break;
            case 22: filledSections = 4; break;
            default: filledSections = 0;
        }


        const data = Array(4).fill(1).map((_, index) => ({
            value: 1,
            color: index < filledSections ? COLORS[index] : "#E0E0E0"
        }));

        return (
            <PieChart width={50} height={50}>
                <Pie
                    data={data}
                    cx="50%" cy="50%"
                    innerRadius={12}  //Empty center size
                    outerRadius={20}  //Total circle size
                    dataKey="value"
                    startAngle={270}
                    endAngle={-180}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Pie>
            </PieChart>

        );
    };

    return (

        <div className="page-content" id="page-content">
            {/*start page title */}
            {isUpdating ? (
                <></>
                /*    <UpdateCollective CloseViewCollective={CloseModalUpdate} CollectiveID={Collective.ord_ID} getCollectives={CollectiveQR} CollectiveQR={CollectiveQR} /> */

            ) : (
                <div>
                    <div className="row justify-content-center">
                        <div className="col-12 card">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center mt-3 p-2">

                                    <div className="text-center flex-grow-1">
                                        <span className="fw-bold">Collective Ref: <Link>{group}</Link></span>
                                    </div>


                                   {/*  <div className="hstack text-nowrap gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Print"
                                            onClick={handleClick}
                                        >
                                            <i className="ri-printer-line"></i>
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-info"
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title="Download"
                                        //onClick={() => downloadCollectivePDF(Collective.ord_ID)}
                                        >
                                            <i className="ri-download-2-line"></i>
                                        </button>
                                    </div> */}
                                </div>

                            </div>
                            <div className="row">
                                <div className="table-responsive" style={{ minHeight: "90vh" }}>
                                    <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                        <thead className="table-light text-muted align-content-center">
                                            <tr style={{ textAlign: "center", verticalAlign: "middle", fontSize: "12px" }}>
                                                <th className="th-hover">ID</th>
                                                <th className="th-hover" >Staff ID</th>
                                                <th className="th-hover" >Customer <br /> Name</th>
                                                <th className="th-hover" >Description</th>
                                                <th className="th-hover" >Status</th>
                                                <th className="th-hover" >Collective <br /> Count</th>
                                                <th className="th-hover" >Metal</th>
                                                <th className="th-hover" >Quantity</th>
                                                <th className="th-hover" >Single QR Data</th>
                                                <th className="th-hover" >Collective QR <br /> Group</th>
                                                <th className="th-hover">Expected <br /> Cast Date</th>
                                            </tr>
                                        </thead>

                                        <tbody className="list form-check-all">
                                            {collective.map((Jobs_L) => (
                                                <tr key={Jobs_L.job_number} style={{ verticalAlign: "middle", fontSize: "12px" }}>
                                                    <td className="id">
                                                        <h6>{Jobs_L.job_number}</h6>
                                                        <p style={{ fontSize: "10px", marginBlock: "0" }}>{Jobs_L.status_name}</p>
                                                    </td>
                                                    <td><strong>{Jobs_L.user_created}</strong></td>
                                                    <td>
                                                        <strong>{Jobs_L.fullname}</strong>
                                                    </td>

                                                    <td>
                                                        {Jobs_L.comment}
                                                    </td>
                                                    <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "10px",
                                                                width: "100%"
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    flex: "1",
                                                                    minWidth: "100px",
                                                                    maxWidth: "200px",
                                                                    textAlign: "left",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                                title={Jobs_L.est_ID === 18 && Jobs_L.reprint > 0 ? "REPRINT FOLDER" : Jobs_L.status_name}
                                                            >
                                                                {Jobs_L.est_ID === 18 && Jobs_L.reprint > 0 ? "REPRINT FOLDER" : Jobs_L.status_name}
                                                            </span>
                                                            <StatusChart
                                                                statusId={Jobs_L.est_ID}
                                                                reprint={Jobs_L.est_ID === 18 && Jobs_L.reprint > 0}
                                                            />
                                                        </span>
                                                    </td>

                                                    <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "10px",
                                                                width: "100%",
                                                                flex: "1",
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    minWidth: "30px",
                                                                    textAlign: "left",
                                                                    fontSize: "14px",
                                                                    flex: "1",
                                                                }}
                                                            >
                                                                {Jobs_L.reprint}
                                                            </span>
                                                            {Jobs_L.reprint > 0 && (
                                                                <i
                                                                    className="ri-shopping-bag-3-fill"
                                                                    style={{ fontSize: "25px", color: "rgb(162 0 0)" }}
                                                                ></i>
                                                            )}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {/*Circle with color */}
                                                        <span
                                                            style={{
                                                                display: "inline-block",
                                                                width: "12px",
                                                                height: "12px",
                                                                backgroundColor: Jobs_L.materials_color || "rgb(226, 226, 226)",
                                                                borderRadius: "50%",
                                                                marginRight: "5px",
                                                            }}
                                                        ></span>

                                                        {/*Material name */}
                                                        {Jobs_L.materials_name}
                                                    </td>


                                                    <td style={{ textAlign: "right" }}>
                                                        {Jobs_L.qty}
                                                    </td>

                                                    <td >
                                                        {Jobs_L?.barcode && (
                                                            <>
                                                                <QRCode
                                                                    size={25}
                                                                    style={{ height: "10vh", width: "10vh" }}
                                                                    value={`${server_frontend}/jobs/qr-single-job?qr=${Jobs_L.barcode}`}
                                                                    viewBox="0 0 256 256"
                                                                />
                                                            </>
                                                        )}
                                                    </td>

                                                    <td >
                                                        {Jobs_L?.qrcode && (
                                                            <>
                                                                <QRCode
                                                                    size={25}
                                                                    style={{ height: "10vh", width: "10vh" }}
                                                                    value={`${server_frontend}/orders/qr-group?trs=1&qr=${Jobs_L.qrcode}`}
                                                                    viewBox="0 0 256 256"
                                                                />
                                                            </>
                                                        )}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        {vAdminformat.FormatDateSmall(Jobs_L.date_estimated)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>

    )
}


export default CollectiveQRForm;